var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveFormat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M336 416h-11.2l9.3-27.8L267 336.4 240.5 416H208a16 16 0 0 0 -16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0 -16-16zm297.8 42.1L377 259.6 426.2 112H544v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0 -16-16H176a16 16 0 0 0 -16 16v43.9L45.5 3.4A16 16 0 0 0 23 6.2L3.4 31.5a16 16 0 0 0 2.8 22.5l588.4 454.7a16 16 0 0 0 22.5-2.8l19.6-25.3a16 16 0 0 0 -2.8-22.5zM309.9 207.8L224 141.4V112h117.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveFormat);
export default __webpack_public_path__ + "static/media/remove_format.d81b361e.svg";
export { ForwardRef as ReactComponent };